import React from 'react';
import '../styles/components/Input.css';

const Input = ({ label, placeholder, error, className = '', ...props }) => {
  return (
    <div className='input-container'>
      {label && <label className='input-label'>{label}</label>}
      <input
        className={`input-field ${className}`}
        placeholder={placeholder}
        {...props}
      />
    </div>
  );
};

export default Input;
